export enum HomeModes {
  create = 'create',
  experience = 'experience'
}

export enum HomeInitialDirection {
  create = 'build',
  experience = 'explore'
}

const HomeInitialAbility = 'capsule';

// Default capability shown when the page loads. Must match a `key` in
// `home-page-mission.tsx` capabilities array; "collaborative" is the
// most central by 3D position (x: 0, y: 1.15, z: 1.1).
const HomeInitialCapability = 'collaborative';

export { HomeInitialAbility, HomeInitialCapability };
